import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import numeral from "numeral";

const TotalAmountField = props => {
  const { totalAmount } = props;

  let importo = numeral(Math.abs(totalAmount)).format("0,0.00");
  const iconColor = totalAmount > 0 ? "#0d6c80" : "#c53090";
  const iconTitle = totalAmount > 0 ? "plus-circle" : "minus-circle";

  return (
    <React.Fragment>
      <div>
        <FontAwesomeIcon
          style={{ color: iconColor, marginRight: "5px" }}
          icon={["fas", iconTitle]}
        />{" "}
        {importo + " €"}{" "}
      </div>
    </React.Fragment>
  );
};

export default TotalAmountField;
